import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
  month: number;
  year: number;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
  month: moment().month() + 1,
  year: moment().year(),
};

const getListArriveLateManagerSlice = createSlice({
  name: "getListArriveLateManager",
  initialState,
  reducers: {
    setMonthYearListArriveLateManager: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListArriveLateManagerStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListArriveLateManagerSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    updateListArriveLateManager: (state, action) => {
      state.data = action.payload;
    },
    getListArriveLateManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListArriveLateManager: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListArriveLateManager,
  getListArriveLateManagerStart,
  getListArriveLateManagerSuccess,
  getListArriveLateManagerFailed,
  resetListArriveLateManager,
  updateListArriveLateManager,
} = getListArriveLateManagerSlice.actions;

export default getListArriveLateManagerSlice.reducer;
